import { render } from "./closeButton.vue?vue&type=template&id=492da286"
import script from "./closeButton.vue?vue&type=script&lang=js"
export * from "./closeButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__